import { render, staticRenderFns } from "./BtnDownloadSeguros.vue?vue&type=template&id=5a5acbc8&"
import script from "./BtnDownloadSeguros.vue?vue&type=script&lang=js&"
export * from "./BtnDownloadSeguros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports